import { TFunction } from 'i18next'

import { ObjectItem } from '../../../../../entities/objects/types/object.types'

type CategoryItem = { title: string; key: string; children: any[] }

export const createObjectTree = (objects: ObjectItem[], t: TFunction, checked: Set<number> = new Set()) => {
  const checkedKeys: string[] = []
  const categoriesMap = new Map<string, CategoryItem>()
  objects.forEach((object) => {
    const key = `${object.category}-${object.id}`
    const childItem = {
      title: object.name,
      key,
    }

    if (checked.size && checked.has(object.id)) {
      checkedKeys.push(key)
    } else if (!checked.size) {
      checkedKeys.push(key)
    }

    if (categoriesMap.has(object.category)) {
      const category = categoriesMap.get(object.category) as CategoryItem
      const children = category.children
      children.push(childItem)
      categoriesMap.set(object.category, {
        ...category,
        children,
      })
    } else {
      categoriesMap.set(object.category, {
        title: object.categoryDetail?.name ? object.categoryDetail?.name : t(`objectsPage.categoryNotProvided`),
        key: object.category,
        children: [childItem],
      })
    }
  })

  return {
    objectsTree: Array.from(categoriesMap.values()),
    checkedKeys,
  }
}
